/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'app.bsky.notification.defs'

export { $nsid }

type RecordDeleted = { $type?: 'app.bsky.notification.defs#recordDeleted' }

export type { RecordDeleted }

const recordDeleted = l.typedObject<RecordDeleted>(
  $nsid,
  'recordDeleted',
  l.object({}),
)

export { recordDeleted }

type ChatPreference = {
  $type?: 'app.bsky.notification.defs#chatPreference'
  include: 'all' | 'accepted' | l.UnknownString
  push: boolean
}

export type { ChatPreference }

const chatPreference = l.typedObject<ChatPreference>(
  $nsid,
  'chatPreference',
  l.object({
    include: l.string<{ knownValues: ['all', 'accepted'] }>(),
    push: l.boolean(),
  }),
)

export { chatPreference }

type FilterablePreference = {
  $type?: 'app.bsky.notification.defs#filterablePreference'
  include: 'all' | 'follows' | l.UnknownString
  list: boolean
  push: boolean
}

export type { FilterablePreference }

const filterablePreference = l.typedObject<FilterablePreference>(
  $nsid,
  'filterablePreference',
  l.object({
    include: l.string<{ knownValues: ['all', 'follows'] }>(),
    list: l.boolean(),
    push: l.boolean(),
  }),
)

export { filterablePreference }

type Preference = {
  $type?: 'app.bsky.notification.defs#preference'
  list: boolean
  push: boolean
}

export type { Preference }

const preference = l.typedObject<Preference>(
  $nsid,
  'preference',
  l.object({ list: l.boolean(), push: l.boolean() }),
)

export { preference }

type Preferences = {
  $type?: 'app.bsky.notification.defs#preferences'
  chat: ChatPreference
  follow: FilterablePreference
  like: FilterablePreference
  likeViaRepost: FilterablePreference
  mention: FilterablePreference
  quote: FilterablePreference
  reply: FilterablePreference
  repost: FilterablePreference
  repostViaRepost: FilterablePreference
  starterpackJoined: Preference
  subscribedPost: Preference
  unverified: Preference
  verified: Preference
}

export type { Preferences }

const preferences = l.typedObject<Preferences>(
  $nsid,
  'preferences',
  l.object({
    chat: l.ref<ChatPreference>((() => chatPreference) as any),
    follow: l.ref<FilterablePreference>((() => filterablePreference) as any),
    like: l.ref<FilterablePreference>((() => filterablePreference) as any),
    likeViaRepost: l.ref<FilterablePreference>(
      (() => filterablePreference) as any,
    ),
    mention: l.ref<FilterablePreference>((() => filterablePreference) as any),
    quote: l.ref<FilterablePreference>((() => filterablePreference) as any),
    reply: l.ref<FilterablePreference>((() => filterablePreference) as any),
    repost: l.ref<FilterablePreference>((() => filterablePreference) as any),
    repostViaRepost: l.ref<FilterablePreference>(
      (() => filterablePreference) as any,
    ),
    starterpackJoined: l.ref<Preference>((() => preference) as any),
    subscribedPost: l.ref<Preference>((() => preference) as any),
    unverified: l.ref<Preference>((() => preference) as any),
    verified: l.ref<Preference>((() => preference) as any),
  }),
)

export { preferences }

type ActivitySubscription = {
  $type?: 'app.bsky.notification.defs#activitySubscription'
  post: boolean
  reply: boolean
}

export type { ActivitySubscription }

const activitySubscription = l.typedObject<ActivitySubscription>(
  $nsid,
  'activitySubscription',
  l.object({ post: l.boolean(), reply: l.boolean() }),
)

export { activitySubscription }

/** Object used to store activity subscription data in stash. */
type SubjectActivitySubscription = {
  $type?: 'app.bsky.notification.defs#subjectActivitySubscription'
  subject: l.DidString
  activitySubscription: ActivitySubscription
}

export type { SubjectActivitySubscription }

/** Object used to store activity subscription data in stash. */
const subjectActivitySubscription = l.typedObject<SubjectActivitySubscription>(
  $nsid,
  'subjectActivitySubscription',
  l.object({
    subject: l.string({ format: 'did' }),
    activitySubscription: l.ref<ActivitySubscription>(
      (() => activitySubscription) as any,
    ),
  }),
)

export { subjectActivitySubscription }
